(function () {
  'use strict';

  let wordFrequencyData = null;
  let wordFrequencySorted = null;
  let loadingPromise = null;

  function loadWordFrequencyData() {
    if (loadingPromise) {
      return loadingPromise;
    }

    if (wordFrequencyData) {
      return Promise.resolve(wordFrequencyData);
    }

    const cdnUrl =
      'https://netwrckstatic.netwrck.com/static/data/word-frequencies.json';
    const localUrl = '/static/data/word-frequencies.json';

    loadingPromise = fetch(cdnUrl)
      .then((response) => {
        if (!response.ok) {
          console.warn(`CDN failed (${response.status}), trying local URL...`);
          return fetch(localUrl);
        }
        return response;
      })
      .catch((error) => {
        console.warn(
          'CDN request failed:',
          error.message,
          '- trying local URL...'
        );
        return fetch(localUrl);
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Failed to load word frequencies: ${response.status}`
          );
        }
        return response.json();
      })
      .then((data) => {
        wordFrequencyData = data;

        wordFrequencySorted = Object.keys(data).sort(
          (a, b) => data[b] - data[a]
        );

        return data;
      })
      .catch((error) => {
        console.error('Failed to load word frequency data:', error);

        wordFrequencyData = {};
        wordFrequencySorted = [];
        return {};
      });

    return loadingPromise;
  }

  function getWordFrequency(word) {
    if (!wordFrequencyData) {
      return 0;
    }
    return wordFrequencyData[word] || 0;
  }

  function getSortedWords() {
    if (!wordFrequencySorted) {
      return [];
    }
    return wordFrequencySorted;
  }

  function isLoaded() {
    return wordFrequencyData !== null;
  }

  function getTopWords(count = 100) {
    if (!isLoaded()) {
      return [];
    }

    return wordFrequencySorted.slice(0, count).map((word) => ({
      word: word,
      frequency: wordFrequencyData[word],
    }));
  }

  window.WordFrequencyLoader = {
    load: loadWordFrequencyData,
    getFrequency: getWordFrequency,
    getSorted: getSortedWords,
    getTop: getTopWords,
    isLoaded: isLoaded,
  };

  Object.defineProperty(window, 'top_used_words', {
    get: function () {
      if (!isLoaded()) {
        return {};
      }
      return wordFrequencyData;
    },
    configurable: true,
  });

  Object.defineProperty(window, 'top_used_words_sorted', {
    get: function () {
      if (!isLoaded()) {
        return [];
      }
      return wordFrequencySorted;
    },
    configurable: true,
  });

  if (!window.__wordFreqInit) {
    window.__wordFreqInit = true;
    // Kick off loading in background once per page
    try {
      loadWordFrequencyData();
    } catch (e) {
      if (
        typeof process !== 'undefined' &&
        process.env &&
        process.env.VERBOSE_TESTS
      ) {
        console.warn('[WordFreq] loadWordFrequencyData failed:', e);
      }
    }
  }
})();
